module.exports = __webpack_public_path__ + "img/page.71451cfb.png";